export const BEST_RATE_ID = 'best-rate';
export const BEST_RATE_TEXT = 'Best Available Rates';
